import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceNotification {
    lookupService = new APIServiceLookUp();

    async getAllNotification(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}notification/getAllNotification`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setNotification(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}notification/setNotification`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delNotification(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}notification/delNotification`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

}
